import VueSelect from "./vselect.vue";


export default VueSelect;

export {VueSelect};
